import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const FooterTwitch: React.FC<SvgIconProps> = ({
  width = 28,
  height = 29,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    viewBox='0 0 28 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <path
      d='M12.8852 20.0015L15.3352 17.5515H18.1461L20.8914 14.8062V7.09521H9.74609V17.5296H12.8852V20.0015ZM17.4461 9.46865H18.7914V13.7343H17.4461V9.46865ZM13.5852 9.46865H14.9305V13.7343H13.5852V9.46865Z'
      fill={fill}
    />
    <path
      d='M0 0.5V28.5H28V0.5H0ZM22.3453 15.4953L16.0781 21.7625H13.2234L9.74531 25.2406V21.7953H5.55625V9.10781L8.97969 5.68438H22.3453V15.4953Z'
      fill={fill}
    />
  </svg>
)

export default FooterTwitch
